import React from 'react'
import { IProps, TabbedSolutions } from 'marketing-site/src/library/components/TabbedSolutions'

import {
  IPlanColumnGroupLayout,
  ISolutionWithTiers,
  ITabbedSolutions as IContentfulTabbedSolutions,
} from 'marketing-site/@types/generated/contentful'
import { transformSolutionWithTiers } from 'marketing-site/src/transformers/components/ContentfulSolutionWithTiers'
import { transformPlanColumnGroupLayout } from 'marketing-site/src/transformers/components/ContentfulPlanColumnGroupLayout'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulTabbedSolutions = (data: IContentfulTabbedSolutions) => {
  return (
    <EntryMarker entry={data}>
      {() => <TabbedSolutions {...transformTabbedSolutions(data)} />}
    </EntryMarker>
  )
}

export function transformTabbedSolutions(data: IContentfulTabbedSolutions): IProps {
  const showHelp =
    data.fields.showHelp && !!data.fields.allInOneHelpText && !!data.fields.otherSolutionsHelpText
  const helpText = {
    allInOneHelpText: data.fields.allInOneHelpText,
    otherSolutionsHelpText: data.fields.otherSolutionsHelpText,
  }
  const solutions = data.fields.solutions.map((solution) => {
    if (solution.sys.contentType.sys.id === 'solutionWithTiers') {
      return transformSolutionWithTiers(solution as ISolutionWithTiers)
    } else if (solution.sys.contentType.sys.id === 'planColumnGroupLayout') {
      return transformPlanColumnGroupLayout(solution as IPlanColumnGroupLayout)
    } else {
      throw 'Wrong solution type'
    }
  })

  return {
    ...data.fields,
    helpText,
    showHelp,
    solutions,
  }
}
